'use strict';

namespace ekh {

    type TripService = Core.TripService;
    class ClearBasketAlert {
        postClearAction: () => ng.IPromise<any>;
        cancelAction: () => void;

		constructor(
            private basketStore,
            private modalService: any,
            private tripService: TripService,
            private $location: ng.ILocationService,
            private $window: ng.IWindowService,
            private $routeParams
			){
            this.basketStore.getProductCount().then((count) => {
                if(count > 0) {
                    return this.modalService.launch('partials/home/directivetemplate?type=clearBasketAlert', {
                        postClearAction: this.postClearAction,
                        cancelAction: this.cancelAction
                    }, true);
                }

                this.basketStore.createBasket()
                    .then(basket => {
                        if (this.$routeParams.tripId) {
                            return this.tripService.setBasketId(this.$routeParams.tripId, basket.BasketId);
                        }
                    })
                    .then(() => {
                        if (this.postClearAction) {
                            this.postClearAction().then(() => {
                            if (_.includes(this.$location.path(), '/dp/book/')) {
                                this.$location.path('');
                            }
                            this.$window.location.reload();
                            });
                        }
                    });
            });
		};
    }

    class ClearBasketAlertModal {
        postClearAction: () => ng.IPromise<any>;
        cancelAction: () => void;

        constructor(
            private basketStore,
            private modalService: any,
            private $location: ng.ILocationService,
            private $window: ng.IWindowService,
            private tripService: TripService,
            private $routeParams
        ){
            this.postClearAction = modalService.get('postClearAction');
            this.cancelAction = modalService.get('cancelAction');
        };

        clear (): void {
            return this.basketStore.createBasket()
                .then(basket => {
                    if (this.$routeParams.tripId) {
                        return this.tripService.setBasketId(this.$routeParams.tripId, basket.BasketId);
                    }
                })
                .then(() => {
                    if (this.postClearAction) {
                        return this.postClearAction();
                    }
                })
                .then(() => {
                    this.modalService.close();
                    if(_.includes(this.$location.path(), '/dp/book/')) {
                        this.$location.path('');
                    }
                    this.$window.location.reload();
                });
        }

        cancel (): void {
            if(this.cancelAction) {
                this.cancelAction();
            }
            this.modalService.close();
        }
    }

    angular
        .module('ekh')
        .directive('clearBasketAlert', () => {
            return {
                restrict: 'E',
                scope: {
                    'postClearAction': '&?onClear',
                    'cancelAction': '&cancel'
                },
                bindToController : true,
                controller: ClearBasketAlert,
                controllerAs: 'cba'
            };
        });

    angular
        .module('ekh')
        .controller('ClearBasketAlertModal', ClearBasketAlertModal);
}
